import { useCallback } from "react";

import type * as ModelType from "@/components/features/faq/model/type";

import * as Composition from "./composition";

import type { SearchedContent } from "./type";

export const useSearchContents = () => {
	return useCallback(
		(
			searchText: string,
			host: ModelType.QueryData["host"],
			guest: ModelType.QueryData["guest"],
		): { hostContents: SearchedContent; guestContents: SearchedContent } => {
			const hostContents = Composition.Converter.searchContentsConverter(searchText, host.contents);
			const guestContents = Composition.Converter.searchContentsConverter(searchText, guest.contents);
			return { hostContents, guestContents };
		},
		[],
	);
};
